import vert from '!raw-loader!./vertex.glsl';
import frag from '!raw-loader!./fragment.glsl';

function loadTexture(gl, oc) {
  const texture = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, texture);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, oc); // This is the important line!
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
  gl.bindTexture(gl.TEXTURE_2D, null);
  return texture;
}

function setArrays(gl, prog) {
  let vertex_buffer = gl.createBuffer();
  const vertices = [-1.0, -1.0, 1.0, -1.0, -1.0, 1.0,
    1.0, 1.0, 1.0, -1.0, -1.0, 1.0,
  ];
  gl.bindBuffer(gl.ARRAY_BUFFER, vertex_buffer);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertices), gl.STATIC_DRAW);
  let coord = gl.getAttribLocation(prog, "coords");
  gl.vertexAttribPointer(coord, 2, gl.FLOAT, false, 0, 0);
  gl.enableVertexAttribArray(coord);
  return [coord, vertex_buffer];
}

function prepareWebGL(gl, width, height) {
  let vertSh = gl.createShader(gl.VERTEX_SHADER);
  gl.shaderSource(vertSh, vert);
  gl.compileShader(vertSh);
  let fragSh = gl.createShader(gl.FRAGMENT_SHADER);
  gl.shaderSource(fragSh, frag);
  gl.compileShader(fragSh);
  let prog = gl.createProgram();
  gl.attachShader(prog, vertSh);
  gl.attachShader(prog, fragSh);
  gl.linkProgram(prog);
  gl.useProgram(prog);
  gl.viewport(0,0, width, height);
  return prog;
}

let webglCanvas = document.createElement("canvas");

const enhanceCanvas = (canvasElement, useNewCanvas = false) => {

  let wgl = useNewCanvas ? document.createElement('canvas') : webglCanvas;

  if (!wgl.gl || useNewCanvas) {
    wgl.width = canvasElement.width;
    wgl.height = canvasElement.height;
    wgl.gl = wgl.getContext("webgl");
    wgl.prog = prepareWebGL(wgl.gl, canvasElement.width, canvasElement.height);
    setArrays(wgl.gl, wgl.prog);
    const uSampler = wgl.gl.getUniformLocation(wgl.prog, 'uSampler');
    wgl.gl.uniform1i(uSampler, 0);
  }

  let gl = wgl.gl;
  const texture = loadTexture(gl, canvasElement);
  let ctx = canvasElement.getContext('2d');

  // render
  gl.activeTexture(gl.TEXTURE0);
  gl.bindTexture(gl.TEXTURE_2D, texture);
  gl.clearColor(0.0, 0.0, 0.0, 1.0);
  gl.clear(gl.COLOR_BUFFER_BIT);
  gl.drawArrays(gl.TRIANGLES, 0, 6);
  ctx.drawImage(wgl, 0, 0, wgl.width, wgl.height, 0, 0, canvasElement.width, canvasElement.height);
  // render end

}

export default enhanceCanvas
